{
  "primer": {
    "eyebrow": "Время намаза и Кибла",
    "headline": "Rhemn нужно ваше местоположение для времени намаза и Киблы.",
    "body": "Мы используем его только для времени намаза, направления Киблы и местной погоды — больше ни для чего.",
    "cta": "Продолжить",
    "skip": "Не сейчас",
    "skip_body": "Время намаза и Кибла останутся выключенными."
  }
}
